import React, { Component } from 'react';

class Erro404 extends Component {
    render() {
        return (
            <div>
                <div className="vc_row wpb_row section vc_row-fluid " style={{ textAlign: 'left' }}>
                    <div className=" full_section_inner clearfix">
                        <div className="wpb_column vc_column_container vc_col-sm-2">
                            <div className="vc_column-inner">
                                <div className="wpb_wrapper"></div>
                            </div>
                        </div>
                        <div className="wpb_column vc_column_container vc_col-sm-8">
                            <div className="vc_column-inner">
                                <div className="wpb_wrapper">
                                    <div className="image_hover">
                                        <div className="images_holder">
                                            <img itemProp="image" className="" src="images/404.png" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="wpb_column vc_column_container vc_col-sm-2">
                            <div className="vc_column-inner">
                                <div className="wpb_wrapper"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <center>
                <div className="q_circle_text_holder">
                    <a data-itemprop="url" className="icon_with_title_link" href="https://www.cebraspe.org.br" target="_self">Acessar Página Inicial</a>
                    </div>
                </center>
            </div>
        );
    }
}

export default Erro404;
